var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomatedClientCreationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_2147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4281 4.26562C21.3648 6.00115 22.6059 8.38055 22.9208 10.962C23.2357 13.5434 22.6031 16.1513 21.1405 18.3016C19.6778 20.4518 17.4845 21.9982 14.9679 22.6535C12.4513 23.3088 9.78237 23.0285 7.45677 21.8648",
    stroke: "#ADC6FF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.71341 20.2727H5.08744V16.8975",
    stroke: "#ADC6FF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8035 4.24316H19.4295V7.61719",
    stroke: "#ADC6FF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08734 20.2499C3.15609 18.5197 1.91617 16.149 1.59658 13.5759C1.27698 11.0027 1.89931 8.40076 3.34861 6.25066C4.79791 4.10056 6.97628 2.54752 9.48141 1.87837C11.9865 1.20922 14.6492 1.46917 16.9776 2.6102",
    stroke: "#ADC6FF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4615 16.9998C16.4615 15.8777 16.0157 14.8016 15.2223 14.0082C14.4289 13.2148 13.3528 12.769 12.2307 12.769C11.1086 12.769 10.0325 13.2148 9.2391 14.0082C8.44568 14.8016 7.99994 15.8777 7.99994 16.9998",
    stroke: "#2F54EB",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2307 11.9231C13.8663 11.9231 15.1923 10.5972 15.1923 8.96154C15.1923 7.32593 13.8663 6 12.2307 6C10.5951 6 9.26918 7.32593 9.26918 8.96154C9.26918 10.5972 10.5951 11.9231 12.2307 11.9231Z",
    stroke: "#2F54EB",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_2147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedClientCreationIcon);
export default __webpack_public_path__ + "static/media/AutomatedClientCreationIcon.1599aff647be24dc55584daf427d7bb6.svg";
export { ForwardRef as ReactComponent };